import { CalendarIcon } from "@/app/design-system/icons";

import { NavigationMenuItem } from "../../components.utility/navigation-menu-item";

interface MyAvailabilityMenuItemProps {
  isCollapsed: boolean;
}

export function MyAvailabilityMenuItem({
  isCollapsed,
}: MyAvailabilityMenuItemProps) {
  const menuItemName = "My schedule";
  return (
    <NavigationMenuItem
      menuItemTooltipContent={menuItemName}
      to="/availability/weekly-calendar"
      isCollapsed={isCollapsed}
    >
      <CalendarIcon
        aria-hidden={!isCollapsed}
        title={!isCollapsed ? "" : menuItemName}
      />
      {!isCollapsed ? menuItemName : null}
    </NavigationMenuItem>
  );
}
